import React, {forwardRef} from 'react'

import './SectionSpacer.scss'

/**
 * Section spacer
 */
export const SectionSpacer = forwardRef((props, ref) => {
  return (
    <div className={'o-spacer'}></div>
  )
})
